import { AreaFilterMapper } from "@app/routing/mappers/AreaFilterMapper";
import { AttendanceFilterMapper } from "@app/routing/mappers/AttendanceFilterMapper";
import { ContinentFilterMapper } from "@app/routing/mappers/ContinentFilterMapper";
import { CountryFilterMapper } from "@app/routing/mappers/CountryFilterMapper";
import { DegreeTypeFilterMapper } from "@app/routing/mappers/DegreeTypeFilterMapper";
import { DensitiesFilterMapper } from "@app/routing/mappers/DensitiesFilterMapper";
import { DisciplineFilterMapper } from "@app/routing/mappers/DisciplineFilterMapper";
import { DurationFilterMapper } from "@app/routing/mappers/DurationFilterMapper";
import { EducationalFormFilterMapper } from "@app/routing/mappers/EducationalFormFilterMapper";
import { EducationalLevelFilterMapper } from "@app/routing/mappers/EducationalLevelFilterMapper";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { KeywordFilterMapper } from "@app/routing/mappers/KeywordFilterMapper";
import { OrganisationFilterMapper } from "@app/routing/mappers/OrganisationFilterMapper";
import { SpecialProgrammesFilterMapper } from "@app/routing/mappers/SpecialProgrammesFilterMapper";
import { TuitionFeeFilterMapper } from "@app/routing/mappers/TuitionFeeFilterMapper";

export const availableFilterMappers: FilterMapper[] = [
	EducationalLevelFilterMapper.getInstance(),
	CountryFilterMapper.getInstance(),
	DisciplineFilterMapper.getInstance(),
	ContinentFilterMapper.getInstance(),
	AreaFilterMapper.getInstance(), //Problematic with region and country together
	AttendanceFilterMapper.getInstance(),
	DurationFilterMapper.getInstance(),
	DegreeTypeFilterMapper.getInstance(),
	EducationalFormFilterMapper.getInstance(),
	SpecialProgrammesFilterMapper.getInstance(),
	TuitionFeeFilterMapper.getInstance(),
	DensitiesFilterMapper.getInstance(),
	OrganisationFilterMapper.getInstance(),
	KeywordFilterMapper.getInstance()
];